// extracted by mini-css-extract-plugin
export default {"faqItem":"faqItem_faqItem__DqvTx","active":"faqItem_active__HEUur","caretDown":"faqItem_caretDown__lekCJ","answer":"faqItem_answer__7SeEd"};